import React from "react";
import { Route, Redirect, Switch, useHistory } from "react-router-dom";
import { Security, LoginCallback } from "@okta/okta-react";
import loadable from '@loadable/component';
import GuestLayout from './components/GuestLayout';
import AuthorizedLayout from './components/AuthorizedLayout';
import OktaSecureHome from './components/routecomponents/OktaSecureHome';
import OktaRedirectHome from './components/OktaRedirectHome';
import OktaLogout from './components/routecomponents/OktaLogout';
import FileNotFound from './components/routecomponents/FileNotFound';
import Unauthorized from './components/routecomponents/Unauthorized';
import { OktaSecuredRoute } from './OktaSecuredRoute';

const fallback = <div>loading....</div>;
const Home = loadable(() => import('./components/routecomponents/Home'), {
    fallback,
});
const ReeferStatus = loadable(() => import('./components/routecomponents/ReeferStatus'), {
    fallback,
});
const ReeferDetails = loadable(() => import('./components/routecomponents/ReeferDetails'), {
    fallback,
});
const MyProfile = loadable(() => import('./components/routecomponents/MyProfile'), {
    fallback,
});
const GensetStatus = loadable(() => import('./components/routecomponents/GensetStatus'), {
    fallback,
});
const DryStatus = loadable(() => import('./components/routecomponents/DryStatusSSRM'), {
    fallback,
});
const GeofenceManagement = loadable(() => import('./components/routecomponents/GeofenceManagement'), {
    fallback,
});
const ReeferCommandStatus = loadable(() => import('./components/routecomponents/ReeferCommandStatusSearch'), {
    fallback,
});
const PreferenceSettings = loadable(() => import('./components/routecomponents/PreferenceSettings'), {
    fallback,
});
const RcdStatus = loadable(() => import('./components/routecomponents/RcdStatus'), {
    fallback,
});

const UserSearch = loadable(() => import('./components/routecomponents/UserSearch').then(m => m.UserSearch), {
    fallback,
});
const CargoCareProfiles = loadable(() => import('./components/routecomponents/CargoCareProfiles').then(m => m.CargoCareProfiles), {
    fallback,
});
const GroupManagement = loadable(() => import('./components/routecomponents/GroupManagement').then(m => m.GroupManagement), {
    fallback,
});
const FleetManagement = loadable(() => import('./components/routecomponents/FleetManagement'), {
    fallback,
});
const AccessDenied = loadable(() => import('./components/routecomponents/AccessDenied'), {
    fallback,
});
const AssetSearch = loadable(() => import('./components/routecomponents/AssetSearch').then(m => m.AssetSearch), {
    fallback,
});
const DeviceSearch = loadable(() => import('./components/routecomponents/DeviceSearch').then(m => m.DeviceSearch), {
    fallback,
});
const SubscriptionManager = loadable(() => import('./components/routecomponents/SubscriptionManager'), {
    fallback,
});
const AdminCargoCareSettings = loadable(() => import('./components/routecomponents/AdminCargoCareSettings'), {
    fallback,
});
const CustomAttributes = loadable(() => import('./components/routecomponents/CustomAttributes'), {
    fallback,
});
const VesselStatus = loadable(() => import('./components/routecomponents/VesselStatus'), {
    fallback,
});
const BookingAssignEdit = loadable(() => import('./components/routecomponents/BookingAssignEdit').then(m => m.BookingAssignEdit), {
    fallback,
});
const BookingUnAssign = loadable(() => import('./components/routecomponents/BookingUnAssign').then(m => m.BookingUnAssign), {
    fallback,
});
const NewBookingCreate = loadable(() => import('./components/routecomponents/NewBookingCreate').then(m => m.NewBookingCreate), {
    fallback,
});
const NewBookingEdit = loadable(() => import('./components/routecomponents/NewBookingEdit').then(m => m.NewBookingEdit), {
    fallback,
});
const ViewBooking = loadable(() => import('./components/routecomponents/ViewBooking').then(m => m.ViewBooking), {
    fallback,
});
const MenuBookingUnAssign = loadable(() => import('./components/routecomponents/MenuBookingUnAssign').then(m => m.MenuBookingUnAssign), {
    fallback,
});
const GensetCommandStatusSearch = loadable(() => import('./components/routecomponents/GensetCommandStatusSearch'), {
    fallback,
});
const GensetDetails = loadable(() => import('./components/routecomponents/GensetDetails'), {
    fallback,
});
const DryCommandStatusSearch = loadable(() => import('./components/routecomponents/DryCommandStatusSearch'), {
    fallback,
});
const DryDetails = loadable(() => import('./components/routecomponents/DryDetails'), {
    fallback,
});
const ReeferSoftwareDistribute = loadable(() => import('./components/routecomponents/ReeferSoftwareDistribute'), {
    fallback,
});
const RCDFirmwareDistribute = loadable(() => import('./components/routecomponents/RCDFirmwareDistribute'), {
    fallback,
});
const GeofenceDistribute = loadable(() => import('./components/routecomponents/GeofenceDistribute'), {
    fallback,
});
const FileRepository = loadable(() => import('./components/routecomponents/FileRepository'), {
    fallback,
});
const ReeferSoftwareFile = loadable(() => import('./components/routecomponents/ReeferSoftwareFile'), {
    fallback,
});
const RcdFirmwareFile = loadable(() => import('./components/routecomponents/RcdFirmwareFile'), {
    fallback,
});
const GeofenceFile = loadable(() => import('./components/routecomponents/GeofenceFile'), {
    fallback,
});
const GensetHistory = loadable(() => import('./components/routecomponents/GensetHistorySearch'), {
    fallback,
});
const GensetMap = loadable(() => import('./components/routecomponents/GensetMapSearch'), {
    fallback,
});

const ManageGenset = loadable(() => import('./components/routecomponents/ManageGenset').then(m => m.ManageGenset), {
    fallback,
});
const ManageDry = loadable(() => import('./components/routecomponents/ManageDry').then(m => m.ManageDry), {
    fallback,
});
const ManageChassis = loadable(() => import('./components/routecomponents/ManageChassis').then(m => m.ManageChassis), {
    fallback,
});
const ManageReefer = loadable(() => import('./components/routecomponents/ManageReefer').then(m => m.ManageReefer), {
    fallback,
});
const DwellTimeReeferReport = loadable(() => import('./components/routecomponents/DwellTimeReeferReport'), {
    fallback,
});
const DryHistory = loadable(() => import('./components/routecomponents/DryHistorySearch'), {
    fallback,
});
const DryMap = loadable(() => import('./components/routecomponents/DryMapSearch'), {
    fallback,
});
const ReeferHistory = loadable(() => import('./components/routecomponents/ReeferHistorySearch'), {
    fallback,
});
const RcdHistory = loadable(() => import('./components/routecomponents/RcdHistorySearch'), {
    fallback,
});
const ReeferMap = loadable(() => import('./components/routecomponents/ReeferMapSearch'), {
    fallback,
});
const DeploymentStatus = loadable(() => import('./components/routecomponents/DeploymentStatus'), {
    fallback,
});
const DeploymentDetails = loadable(() => import('./components/routecomponents/DeploymentDetails').then(m => m.DeploymentDetails), {
    fallback,
});
const DeploymentStatistics = loadable(() => import('./components/routecomponents/DeploymentStatistics').then(m => m.DeploymentStatistics), {
    fallback,
});
const PowerOnOffReport = loadable(() => import('./components/routecomponents/PowerOnOffReport'), {
    fallback,
});
const DwellTimeReport = loadable(() => import('./components/routecomponents/DwellTimeReport'), {
    fallback,
});
const GravityVectorReport = loadable(() => import('./components/routecomponents/GravityVectorReport'), {
    fallback,
});
const FuelGainReport = loadable(() => import('./components/routecomponents/FuelGainReport'), {
    fallback,
});
const FuelLossReport = loadable(() => import('./components/routecomponents/FuelLossReport'), {
    fallback,
});
const ShorePowerReport = loadable(() => import('./components/routecomponents/ShorePowerReport'), {
    fallback,
});
const EngineHourReport = loadable(() => import('./components/routecomponents/EngineHourReport'), {
    fallback,
});
const DwellTimeDryReport = loadable(() => import('./components/routecomponents/DwellTimeDryReport'), {
    fallback,
});
const FeedBack = loadable(() => import('./components/routecomponents/FeedBack'), {
    fallback,
});
const UserGuide = loadable(() => import('./components/routecomponents/UserGuide'), {
    fallback,
});
const ReleaseNotes = loadable(() => import('./components/routecomponents/ReleaseNotes'), {
    fallback,
});
const OktaOINConfigGuide = loadable(() => import('./components/routecomponents/OktaOINConfigGuide'), {
    fallback,
});
const ContactUs = loadable(() => import('./components/routecomponents/ContactUs'), {
    fallback,
});
const ChassisStatus = loadable(() => import('./components/routecomponents/ChassisStatus'), {
    fallback,
});
const ChassisHistory = loadable(() => import('./components/routecomponents/ChassisHistorySearch'), {
    fallback,
});
const ChassisMap = loadable(() => import('./components/routecomponents/ChassisMapSearch'), {
    fallback,
});
const ChassisDetails = loadable(() => import('./components/routecomponents/ChassisDetails'), {
    fallback,
});
const CommandManagement = loadable(() => import('./components/routecomponents/CommandManagement').then(m => m.CommandManagement), {
    fallback,
});

var Config: any = require('./Config.json');

const CALLBACK_PATH = "/implicit/callback";

let oktabaseURI = window.location.href;
var oauthHomePath = sessionStorage.getItem('KeyWord');

if (sessionStorage.getItem('KeyWord') == null) {

    var lastTagName = oktabaseURI.split("/").pop();
    let validKeyWords = Config.ValidOAuthKeyWords;
    let arrValidKeywords = validKeyWords.split(",");
    if (arrValidKeywords.indexOf(lastTagName) !== -1) {
         oauthHomePath = "/" + lastTagName;
    }
} else {
    var lastTagName = sessionStorage.getItem('KeyWord');
     oauthHomePath = "/" + lastTagName;
}

const OktaApp = (props) => {
    const history = useHistory();
    const restoreOriginalUri = async (_oktaAuth: any, originalUri: any) => {
        history.replace(oauthHomePath);        
    };
    
    return (
        <Security oktaAuth={props.auth} restoreOriginalUri={restoreOriginalUri}>
            <Switch>
                <Route path={oauthHomePath} exact component={OktaRedirectHome} />
                <Route path={CALLBACK_PATH} exact component={LoginCallback} />
                <Route layout={GuestLayout} path='/fileNotFound' component={FileNotFound} />
                <Route layout={GuestLayout} path='/unauthorized' component={Unauthorized} />
                <Route layout={GuestLayout} path='/OktaLogout' component={OktaLogout} />
                <OktaSecuredRoute path="/OktaSecureHome" layout={AuthorizedLayout} component={OktaSecureHome} />
                <OktaSecuredRoute path="/home" layout={AuthorizedLayout} component={Home} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/myprofile' component={MyProfile} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/reeferdetails' component={ReeferDetails} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/reeferstatus' component={ReeferStatus} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/gensetstatus' component={GensetStatus} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/drystatus' component={DryStatus} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/chassisstatus' component={ChassisStatus} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/vesselstatus' component={VesselStatus} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/geofencemanagement' component={GeofenceManagement} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/reefercommands' component={ReeferCommandStatus} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/reefercommandstatus' component={ReeferCommandStatus} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/preferencesettings' component={PreferenceSettings} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/usersearch' component={UserSearch} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/cargocareprofiles' component={CargoCareProfiles} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/rcdstatus' component={RcdStatus} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/groupmanagement' component={GroupManagement} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/fleetmanagement' component={FleetManagement} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/cargocaresettings' component={AdminCargoCareSettings} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/customattributes' component={CustomAttributes} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/gensetsearch' component={ManageGenset} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/drysearch' component={ManageDry} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/chassissearch' component={ManageChassis} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/reefersearch' component={ManageReefer} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/devicesearch' component={DeviceSearch} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/subscriptionmanager' component={SubscriptionManager} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/gensetcommandstatus' component={GensetCommandStatusSearch} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/gensetdetails' component={GensetDetails} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/drycommands' component={DryCommandStatusSearch} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/drycommandstatus' component={DryCommandStatusSearch} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/drydetails' component={DryDetails} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/bookingassign' component={BookingAssignEdit} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/bookingunassign' component={BookingUnAssign} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/Newbookingassign' component={NewBookingCreate} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/NewbookingEdit' component={NewBookingEdit} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/ViewBooking' component={ViewBooking} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/unassignbooking' component={MenuBookingUnAssign} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/reefersoftwaredistribute' component={ReeferSoftwareDistribute} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/rcdfirmwaredistribute' component={RCDFirmwareDistribute} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/geofencedistribute' component={GeofenceDistribute} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/filerepository' component={FileRepository} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/deploymentstatus' component={DeploymentStatus} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/deploymentdetails' component={DeploymentDetails} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/deploymentstatistics' component={DeploymentStatistics} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/reefersoftwarefile' component={ReeferSoftwareFile} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/rcdfirmwarefile' component={RcdFirmwareFile} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/geofencefile' component={GeofenceFile} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/gensethistory' component={GensetHistory} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/gensetmap' component={GensetMap} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/dryhistory' component={DryHistory} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/chassishistory' component={ChassisHistory} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/chassisdetails' component={ChassisDetails} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/chassismap' component={ChassisMap} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/drymap' component={DryMap} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/reeferhistory' component={ReeferHistory} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/rcdhistory' component={RcdHistory} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/reefermap' component={ReeferMap} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/poweronoff' component={PowerOnOffReport} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/gensetdwelltime' component={DwellTimeReport} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/gravityvector' component={GravityVectorReport} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/gensetfuelgain' component={FuelGainReport} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/gensetfuelloss' component={FuelLossReport} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/gensetshorepower' component={ShorePowerReport} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/gensetenginehour' component={EngineHourReport} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/drydwelltime' component={DwellTimeDryReport} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/reeferdwelltime' component={DwellTimeReeferReport} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/feedback' component={FeedBack} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/userguide' component={UserGuide} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/releasenotes' component={ReleaseNotes} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/oktaoinconfigguide' component={OktaOINConfigGuide} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/contactus' component={ContactUs} />
                <OktaSecuredRoute layout={AuthorizedLayout} path='/commandmanagement' component={CommandManagement} />
                <Redirect to="/fileNotFound" />               
            </Switch>
        </Security>
    );    

};

export default OktaApp;


/* secure route on entire application
const App = () => {
  return (
    <Router>
      <Security {...config} >
        <Switch>
          <Route path="/login/callback" component={LoginCallback} />
          <SecureRoute path="/" />
        </Switch>
      </Security>
    </Router>
  );
};

*/